import * as React from 'react';
import Paper from '@material-ui/core/Paper';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TablePagination from '@material-ui/core/TablePagination';
import TableRow from '@material-ui/core/TableRow';
import { makeStyles } from "@material-ui/core/styles";
import brandTheme from 'brandTheme/Theme';

const useStyles = makeStyles((theme) => ({
    tableContianer:{
      fontFamily:brandTheme.font.poppins,
      
        maxHeight:'465px',
          '@media only screen and (max-width: 600px)': {
             maxHeight:'400px',
    },
        '&::-webkit-scrollbar-thumb': {
            borderRadius: '10px',
            backgroundColor: brandTheme.grey,  // scroll bar color
        },
        '&::-webkit-scrollbar': {  /* Works on scrollbar for Chrome, Safari and Opera */
            height: '2px',
            width: '10px',
            backgroundColor: 'transparent',
        },
        '&::-webkit-scrollbar-track': {
            borderRadius: '10px',
            backgroundColor: 'transparent',
        },
        "& .MuiTableCell-stickyHeader": {
          backgroundColor: brandTheme.tableHeaderColor,
        },
        "& .MuiTableRow-root.MuiTableRow-hover:hover":{
          backgroundColor:brandTheme.tableHoverColor
        }
    },
    tableRow:{
      padding:'8px 20px 8px 17px',
      '& button':{
        padding:'0px 8px 0px 0px',
      },
    },
    tableRowClickable:{
      padding:'8px 20px 8px 17px',
      cursor:'pointer',
      '& button':{
        padding:'0px 8px 0px 0px',
      },
    },
    tableMainContainer:{
      boxShadow:'inherit',
      width:"90%",
      margin:"0px auto",
        '@media only screen and (max-width: 600px)': {
         width:"auto",
    },
    },
    tableCell:{
      fontWeight:'bold',
    },
    tableHeader:{
     height:'75px',
     padding:'5px 16px',
    },
    tableColumn:{
     height:'65px',
     padding:'5px 16px',
    },
  }));



  const ColumnGroupingTable = ({ columns, rows, clickable, onClickViewData,noPagination,columnHeight,rowPerPageData }) => {
    const classes = useStyles();
    const [page, setPage] = React.useState(0);
    const [rowsPerPage, setRowsPerPage] = React.useState(rowPerPageData || 10);
  
    const handleChangePage = (event, newPage) => {
      setPage(newPage);
    };
  
    const handleChangeRowsPerPage = (event) => {
      setRowsPerPage(+event.target.value);
      setPage(0);
    };
  
    return (
      <Paper className={classes.tableMainContainer}>
        <TableContainer className={classes.tableContianer}>
          <Table stickyHeader aria-label="sticky table">
            <TableHead>
              <TableRow>
                {columns.map((column) => (
                  <TableCell key={column.id} align={column.align} className={`${classes.tableCell} ${columnHeight ? classes.tableHeader : ""}`}>
                    {column.label}
                  </TableCell>
                ))}
              </TableRow>
            </TableHead>
            <TableBody>
              {rows
                .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                .map((row, index) => (
                  <TableRow key={index} hover role="checkbox" tabIndex={-1} onClick={() => (clickable || row?.makeClickable) && onClickViewData(row.viewCode,row?.viewName,row?.viewId)} className={columnHeight ? classes.tableColumn : ""}>
                    {columns.map((column) => (
                      <TableCell key={column.id} align={column.align} className={(clickable || row?.makeClickable) ? classes.tableRowClickable : classes.tableRow}>
                        {column.format && typeof row[column.id] === 'number'
                          ? column.format(row[column.id])
                          : row[column.id]}
                      </TableCell>
                    ))}
                  </TableRow>
                ))}
            </TableBody>
          </Table>
        </TableContainer>
        {!noPagination &&
        <TablePagination
          rowsPerPageOptions={[10, 20]}
          component="div"
          count={rows.length}
          rowsPerPage={rowsPerPage}
          page={page}
          onPageChange={handleChangePage}
          onRowsPerPageChange={handleChangeRowsPerPage}
        />
        }
      </Paper>
    );
  };
  
export default ColumnGroupingTable;